import { historyPatched } from "../lib/history.client";
import { baseLocation } from "../lib/location";
import { mergeState, navigate } from "../lib/navigate.client";
import type { NavigationParameters, ParameterRecord } from "../params/params.types.js";
import { paramTypes } from "../params/params.utils";
import type { NavigationState, StateRecord } from "../state/state.types.js";
import { sanitizeState } from "../state/state.utils";
import { scopeScope } from "./scope.logger.js";
import type { NavigationScopeNavigateOptions } from "./scope.types.js";
import { setScope } from "./utils";

const log = scopeScope.scope("navigate");

export const getScopeNavigate: (
  scopeName: string,
  search: NavigationParameters<ParameterRecord>,
  hash: NavigationParameters<ParameterRecord>,
  scope: NavigationState<StateRecord>,
) => (
  urlOrString?: string | URL,
  options?: NavigationScopeNavigateOptions<StateRecord>,
) => Promise<boolean> = (scopeName, search, hash, scopeState) => {
  const parameters = [
    [paramTypes[0], search],
    [paramTypes[1], hash],
  ] as const;

  return async (urlOrString, o = {}) => {
    /*                     */
    const { history: navigationType = "push", merge: mergeOptions = {} } = o;
    const merge = { hash: true, search: true, ...mergeOptions };

    log.debug("Navigation request", {
      url: urlOrString,
      type: navigationType,
      merge,
      state: o.state,
    });

    /*                                                               */
    if (o.state) scopeState.fromObject(o.state);

    /*                                                       */
    /*                                          */
    /*                                                  */
    const base = new URL(baseLocation.href);
    base.search = "";
    base.hash = "";
    const nextUrl = new URL(urlOrString ?? "", base);

    /*                                                     */

    /*                                                */
    for (const [type, source] of parameters) {
      /*                                                                               */
      /*                                                              */
      if (!merge[type] || nextUrl[type]) source.fromString(nextUrl[type]);

      /*                                                   */
      /*                                                                 */
      /*                                    */
      nextUrl[type] = source.toString(merge[type] ? baseLocation : undefined);
    }

    /*                                                                        */
    const hist = await historyPatched();

    /*                                                            */
    /*                                      */
    /*                                                           */
    const nextState = mergeState(o.rootState, { state: !o.clear }, hist.state);

    /*                                              */
    const stateManaged = setScope(scopeName, sanitizeState(nextState, true), scopeState.toObject());

    /*                                                                     */
    /*                                                                                           */
    log.info("Navigate to", {
      url: nextUrl,
      type: navigationType,
      state: stateManaged,
      merge,
    });
    return navigate(nextUrl, { ...o, scope: scopeName, state: stateManaged });
  };
};
